module.exports = {
  "postbox-text": "Введіть коментар тут (принаймні 3 символи)",
  "postbox-author": "Ім'я (необов'язково)",
  "postbox-author-placeholder": "John Doe",
  "postbox-email": "Пошта (необов'язково)",
  "postbox-email-placeholder": "johndoe@example.com",
  "postbox-website": "Веб-сайт (необов'язково)",
  "postbox-website-placeholder": "https://example.com",
  "postbox-preview": "Прев'ю",
  "postbox-edit": "Редагувати",
  "postbox-submit": "Відправити",
  "postbox-notification": "Підписатися на повідомлення про відповіді поштою",

  "num-comments": "{{ n }} коментар\n{{ n }} коментарі\n{{ n }} коментарів",
  "no-comments": "Коментарів поки нема",
  "atom-feed": "Атомна стрічка",

  "comment-reply": "Відповісти",
  "comment-edit": "Редагувати",
  "comment-save": "Зберегти",
  "comment-delete": "Видалити",
  "comment-confirm": "Підтвердити",
  "comment-close": "Закрити",
  "comment-cancel": "Скасувати",
  "comment-deleted": "Коментар видалено.",
  "comment-queued": "Коментар в черзі на модерацію.",
  "comment-anonymous": "Анонімний",
  "comment-hidden": "{{ n }} Прихований",
  "comment-page-author-suffix": "Автор",

  "date-now": "прямо зараз",
  "date-minute": "хвилину тому\n{{ n }} хвилини тому\n{{ n }}хвилин тому",
  "date-hour": "годину тому\n{{ n }} години тому\n{{ n }} годин тому",
  "date-day": "Вчора\n{{ n }} дні тому\n{{ n }} днів тому",
  "date-week": "минулого тижня\n{{ n }} тижні тому\n{{ n }} тижнів тому",
  "date-month": "останній місяць\n{{ n }} місяці тому\n{{ n }} місяців тому",
  "date-year": "минулого року\n{{ n }} роки тому\n{{ n }} років тому"
};
